import Axios from 'axios';
import { get } from 'lodash-es';
import Cookies from 'js-cookie';
import { FastApiAxiosInstance, FosAxiosInstance } from './axiosInstances';
import { FileACL } from 'common/types';
const CancelToken = Axios.CancelToken;
const uploadByPreSign = {
  //获取上传-预签名链接(单文件)
  getUploadPreSignUrl(params: { fileName; fileSize; acl; path?: string; uuid?: string; contentType: string }) {
    console.log('contentType', params.contentType);
    return FastApiAxiosInstance.post('/api/v2/file/getPreSignedUploadUrl', params)
      .then(({ data }) => {
        console.log('data', data);
        const uploadUrl = get(data, ['preSignedUploadUrl']);
        const downloadUrl = get(data, ['downloadUrl']);
        const fileId = get(data, ['fileId']);
        return {
          uploadUrl,
          downloadUrl,
          fileId,
        };
      })
      .catch(() => {});
  },

  // v0.7.0上传单文件
  uploadSingleFile({ url, file, showMessage = true }) {
    console.log('file', file);

    const myHeaders = new Headers();
    // myHeaders.append("User-Agent", "Apifox/1.0.0 (https://apifox.com)");
    myHeaders.append('Accept', '*/*');
    myHeaders.append('Host', 'fap-fos-dev.apps-sl.danlu.netease.com');
    myHeaders.append('Connection', 'keep-alive');
    myHeaders.append('Content-Type', file.type);

    // upload file to server
    return fetch(url, {
      method: 'PUT',
      body: file,
      redirect: 'follow',
      headers: myHeaders,
    })
      .then(response => response.json())
      .then(res => {
        console.log('res', res);
        // const downloadUrl = get(data, [file.name]);
        // onSuccess?.();
        // showMessage && messageApi.success(`${file.name}上传成功`);
        // return downloadUrl as string;
        return;
      })
      .catch(err => {
        // messageApi.error(`${file.name}上传失败`);
        console.error(err);
        // onError?.();
      });
  },

  // 上传分片
  uploadSlice: async ({ url, blob }) => {
    const fd = new FormData();
    fd.append('file', blob);
    // fd.append('index', seq.toString() + 1);

    // const url = `api/upload_chunk`;
    // const newUrl = url.replace('/proxy-host', '');
    const res = await FosAxiosInstance.post(url, fd, {
      headers: { 'Content-Type': 'multipart/form-data', Cookies: `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}` },
      // cancelToken: new CancelToken(cancelTokenCallback),
    });
    return res;
  },
  //上传文件后由服务端代理，返回能访问的url,解决/api/sdk/upload返回的文件无法被访问问题

  uploadSlicesSuccess({ fileId, chunkUploadId, partEtags }) {
    return FastApiAxiosInstance.post('/api/v2/file/chunkUploadSuccess', {
      fileId,
      chunkUploadId,
      partEtags,
    })
      .then(({ data }) => {
        return data;
      })
      .catch(() => {});
  },

  /* v0.7.0新版分片上传 */
  //从art-backend服务 获取分片上传的id
  getUploadChunkId: async (params: {
    uuid?: string;
    fileName: string;
    fileSize: string;
    acl: FileACL;
    path?: string;
    contentType: string;
  }) => {
    try {
      const { data } = await FastApiAxiosInstance.post('/api/v2/file/getChunkUploadId', params);
      return data;
    } catch (e) {
      return null;
    }
  },
  //获取上传分片的预签名链接
  getUploadSlicePreSignUrl: async (params: { fileId: string; index: number; chunkUploadId: string; acl: FileACL }) => {
    try {
      const { data } = await FastApiAxiosInstance.post('/api/v2/file/getPreSignedChunkUploadUrl', params);
      return data;
    } catch (e) {
      return null;
    }
  },
  //上传分片
  uploadSlices: async (params: {
    uploadUrl: string;
    uploadId: string;
    blob: File;
    start;
    end;
    cancelTokenCallback: any;
    onSuccess;
    onError;
  }) => {
    const fd = new FormData();
    const slice = params.blob.slice(params.start, params.end);
    fd.append('file', slice);

    const url = params.uploadUrl;
    FosAxiosInstance.post(url, fd, {
      headers: { 'Content-Type': 'multipart/form-data', Cookies: `RBAC_TOKEN=${Cookies.get('RBAC_TOKEN')}` },
      cancelToken: new CancelToken(params.cancelTokenCallback),
    })
      .then(res => {
        const isSuc = res?.status === 200;
        if (isSuc) {
          params.onSuccess(res?.data);
        } else {
          return Promise.reject(res);
        }
      })
      .catch(params.onError);
  },
  //获取版本ID
  getUploadVersionId: async (params: { taskId }) => {
    try {
      const { data } = await FastApiAxiosInstance.post('/api/v2/version/getVersionUUID', params);
      return data;
    } catch (e) {
      return null;
    }
  },
};
export default uploadByPreSign;
